import React from "react";
import MasterDataFormV2 from "pages/POS/MasterDataFormV2";

const ATVStatusForm = ({ initialData, onSuccess, onError }) => {
  return (
    <MasterDataFormV2
      title="ATV Status"
      apiUrl="/atv-status"
      initialData={initialData}
      fields={[
        {
          name: "name",
          label: "Status Name",
          type: "text",
          required: true,
          maxLength: 255,
          placeholder: "Enter status name",
        },
      ]}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
};

export default ATVStatusForm;
